module.exports = __webpack_public_path__ + "img/icon-wypedzani-z-raju.png";